
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1ifko_zanzi_145",
  "disable-paddings": "awsui_disable-paddings_1ifko_zanzi_183",
  "main": "awsui_main_1ifko_zanzi_187",
  "content-wrap": "awsui_content-wrap_1ifko_zanzi_193",
  "content": "awsui_content_1ifko_zanzi_193",
  "actions": "awsui_actions_1ifko_zanzi_209"
};
  